import { Span } from "@clipboard-health/ui-components";
import { ArrivalTimeLabel } from "@src/appV2/redesign/ArrivalTime/TimeLabel";
import { BookabilityCriteriaCardTitleText } from "@src/appV2/redesign/Shift/BottomSheet/BookabilityCriteriaCardTitleText";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time
import { utcToZonedTime } from "date-fns-tz";

interface WorkerShiftDetailsArrivalTimeTitleProps {
  targetArrivalTime: Date;
  workplaceTimezone: string;
}

export function WorkerShiftDetailsArrivalTimeTitle(props: WorkerShiftDetailsArrivalTimeTitleProps) {
  const { targetArrivalTime, workplaceTimezone } = props;

  return (
    <BookabilityCriteriaCardTitleText>
      <Span>Please clock in before </Span>
      <ArrivalTimeLabel datetime={utcToZonedTime(targetArrivalTime, workplaceTimezone)} />
    </BookabilityCriteriaCardTitleText>
  );
}
